define('controllers/faq',['require','layout','utils'],function (require) {
    var layout = require('layout');
    var utils = require('utils');
    return {
        load: function (action, data, state) {
            return layout.initStatic('/fe/templates/about/faq').then(function () {
                layout.initGlobalHandlers();
                layout.hideMatchPlanTemplate();
                $('[data-memberSupportEmail]').text(window.ServerData.Emails.MemberSupport);
                $('[data-800Number]').text(window.ServerData.Phones.MemberSupportPhone);
                $("[data-matchPlanPercentage]").text(window.ServerData.Settings.MatchPercentage,);

                var showAll = false;
                //close all answers by default
                //$(".A").parent().hide();
                //showAll = true;

                $(".Q").parent().parent()
                    .on("click", function() {
                        $(this).next().slideToggle('fast');
                    })
                    .on("mouseover", function() { $(this).css("cursor", "pointer"); })
                    .on("mouseout", function() { $(this).css("cursor", "none"); });

                $("#showAllAnswers").on("click", function(e) {
                    e.preventDefault();
                    var answers = $(".A").parent();
                    if (showAll) {
                        answers.show();
                        showAll = false;
                    } else {
                        answers.hide();
                        showAll = true;
                    }
                    gaTrack('FAQ', 'ShowAll', 'Click', showAll ? 1 : 0);
                });

                utils.scrollToElement(action);
            });
        },

        unload: function() {
            $("#showAllAnswers").off('click');
            $(".Q").parent().parent().off('click mouseover mouseout');
        }
    };
});

